<template>
  <div class="h-100">
    <b-container fluid>
      <h1 class="tw-text-3xl tw-font-medium tw-mb-2 text-aegis-dk">ETL Runs</h1>
      <h6 class="tw-font-bolder tw-mb-0">Duration of the past 24 ETL runs</h6>
      <!-- <p class="text-secondary tw-text-sm">Out of 1800 selected for Baseline</p> -->
      <p class="text-secondary tw-text-xs">
        Split between data sync and post-ETL function calls
      </p>
      <bar-chart
        id="etl-bar-chart"
        style="height: 850px;"
        :chartData="chartdata"
        :options="options"
      ></bar-chart>
    </b-container>
  </div>
</template>

<script>
String.prototype.capitalize = function() {
  return this.replace(/(?:^|\s)\S/g, function(a) {
    return a.toUpperCase();
  });
};

import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import * as moment from "moment";

import BarChart from "@/components/charts/BarChart.vue";
export default {
  mixins: [DashboardBaseTemplate],
  components: {
    BarChart,
  },
  data: function() {
    return {
      chartdata: {},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: "bottom",
          labels: {
            boxWidth: 18,
          },
        },
        animation: {
          animateScale: true,
          animateRotate: true,
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: function(tooltipItem, data) {
              if (data.datasets[tooltipItem.datasetIndex].label == "") {
                return null;
              }
              var seconds = parseFloat(tooltipItem.yLabel) * 1000;
              var hours = moment.duration(seconds).hours();
              var minutes = moment.duration(seconds).minutes();
              seconds = moment.duration(seconds).seconds();
              var ms = moment.duration(seconds).milliseconds();

              var tooltip = "";
              if (hours > 0) {
                var label = " hour, ";
                if (hours > 1) {
                  label = " hours, ";
                }
                tooltip += hours + label;
              }
              if (minutes > 0) {
                label = " minute, ";
                if (minutes > 1) {
                  label = " minutes, ";
                }
                tooltip += minutes + label;
              }

              tooltip += seconds + "." + ms + " seconds";
              return (
                data.datasets[tooltipItem.datasetIndex].label + " - " + tooltip
              );
            },
          },
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              barThickness: 20,
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              // barThickness: 20,
              // barPercentage: 0.5,
              stacked: true,
              gridLines: {
                display: false,
              },
              ticks: {
                // convert seconds to minutes
                callback: function(value) {
                  return moment.duration(value, "seconds").minutes() + " mins";
                },
              },
            },
          ],
        },
      },
    };
  },
  computed: {},
  created: function() {},
  mounted: function() {
    this.get();
  },
  methods: {
    randomColor: function() {
      var letters = "0123456789ABCDEF".split("");
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    // ...mapActions('sample', ['nameOfAction']),
    get: function() {
      HTTP.get("kenya/etl-runs")
        .then((response) => {
          var new_labels = [];
          var etl_records = [];
          var etl_types = [];
          let etl_data = response.data;

          for (var i = 0; i < etl_data.length; i++) {
            var next_timestamp = moment(
              etl_data[i].start_time,
              "YYYY-MM-DDTHH:mm:ss.SSSZZ"
            ).format("MMM D - h:mm a");
            if (new_labels.indexOf(next_timestamp) < 0) {
              new_labels.push(next_timestamp);
            }

            // if this is a "main" type, look through it's children
            if (etl_data[i].etl_type == "main") {
              // add this type, only if it's not post-etl
              for (var j = 0; j < etl_data[i].child_runs.length; j++) {
                if (etl_data[i].child_runs[j].etl_type != "post_etl") {
                  etl_records.push({
                    stack: "Forms",
                    group: "main",
                    label: etl_data[i].child_runs[j].etl_type,
                    timestamp: next_timestamp,
                    data: etl_data[i].child_runs[j].time_lapsed,
                  });
                  if (
                    etl_types.indexOf(etl_data[i].child_runs[j].etl_type) < 0
                  ) {
                    etl_types.push(etl_data[i].child_runs[j].etl_type);
                  }
                } else {
                  // then this is a post etl, and it has its own children
                  for (
                    var z = 0;
                    z < etl_data[i].child_runs[j].child_runs.length;
                    z++
                  ) {
                    etl_records.push({
                      stack: "Forms",
                      group: "post-etl",
                      label: etl_data[i].child_runs[j].child_runs[z].etl_type,
                      timestamp: next_timestamp,
                      data: etl_data[i].child_runs[j].child_runs[z].time_lapsed,
                    });
                    if (
                      etl_types.indexOf(
                        etl_data[i].child_runs[j].child_runs[z].etl_type
                      ) < 0
                    ) {
                      etl_types.push(
                        etl_data[i].child_runs[j].child_runs[z].etl_type
                      );
                    }
                  }
                }
              }
            }

            // if this is a "case" type, look through it's children
            if (etl_data[i].etl_type == "cases") {
              // add this type, only if it's not post-etl
              for (j = 0; j < etl_data[i].child_runs.length; j++) {
                // add this type, only if it's not post-etl
                if (etl_data[i].child_runs[j].etl_type != "post_case_etl") {
                  etl_records.push({
                    stack: "Cases",
                    group: "cases",
                    label: etl_data[i].child_runs[j].etl_type,
                    timestamp: next_timestamp,
                    data: etl_data[i].child_runs[j].time_lapsed,
                  });
                  if (
                    etl_types.indexOf(etl_data[i].child_runs[j].etl_type) < 0
                  ) {
                    etl_types.push(etl_data[i].child_runs[j].etl_type);
                  }
                } else {
                  // then this is a post etl, and it has its own children
                  for (
                    z = 0;
                    z < etl_data[i].child_runs[j].child_runs.length;
                    z++
                  ) {
                    etl_records.push({
                      stack: "Cases",
                      group: "post-case-etl",
                      label: etl_data[i].child_runs[j].child_runs[z].etl_type,
                      timestamp: next_timestamp,
                      data: etl_data[i].child_runs[j].child_runs[z].time_lapsed,
                    });
                    if (
                      etl_types.indexOf(
                        etl_data[i].child_runs[j].child_runs[z].etl_type
                      ) < 0
                    ) {
                      etl_types.push(
                        etl_data[i].child_runs[j].child_runs[z].etl_type
                      );
                    }
                  }
                }
              }
            }
          }

          var datasets = [];

          // now loop through the etl types, creating datastes for each of them
          for (var etl_iter = 0; etl_iter < etl_types.length; etl_iter++) {
            var new_dataset = {
              label: etl_types[etl_iter],
              data: [],
            };

            // for this type, run through the labels we have and find matching dates...
            for (
              var label_iter = 0;
              label_iter < new_labels.length;
              label_iter++
            ) {
              var current_timestamp = new_labels[label_iter];

              var match_found = false;
              for (i = 0; i < etl_records.length; i++) {
                if (
                  etl_records[i].label == etl_types[etl_iter] &&
                  etl_records[i].timestamp == current_timestamp
                ) {
                  // then we have a match!  so add the data and make sure the stack is set
                  new_dataset.data.push(etl_records[i].data);
                  new_dataset.stack = etl_records[i].stack;
                  new_dataset.group = etl_records[i].group;
                  match_found = true;
                }
              }

              if (!match_found) {
                new_dataset.data.push(0);
              }
            }
            datasets.push(new_dataset);
          }

          var new_chart_data = {
            datasets: datasets,
            labels: new_labels,
          };

          this.chartdata = this.set_colors(new_chart_data);
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    // NOTE: the following two functions were taken from Stack Overflow:
    // https://graphicdesign.stackexchange.com/questions/83866/generating-a-series-of-colors-between-two-colors

    // Returns a single rgb color interpolation between given rgb color
    // based on the factor given; via https://codepen.io/njmcode/pen/axoyD?editors=0010
    interpolateColor: function(color1, color2, factor) {
      if (arguments.length < 3) {
        factor = 0.5;
      }
      var result = color1.slice();
      for (var i = 0; i < 3; i++) {
        result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
      }
      return result;
    },

    // My function to interpolate between two colors completely, returning an array
    interpolateColors: function(color1, color2, steps) {
      var stepFactor = 1 / (steps - 1),
        interpolatedColorArray = [];

      color1 = color1.match(/\d+/g).map(Number);
      color2 = color2.match(/\d+/g).map(Number);

      for (var i = 0; i < steps; i++) {
        interpolatedColorArray.push(
          this.interpolateColor(color1, color2, stepFactor * i)
        );
      }

      return interpolatedColorArray;
    },
    rgbToHex: function(rgb) {
      var hex = Number(rgb).toString(16);
      if (hex.length < 2) {
        hex = "0" + hex;
      }
      return hex;
    },
    fullColorHex: function(rgb_list) {
      var red = this.rgbToHex(rgb_list[0]);
      var green = this.rgbToHex(rgb_list[1]);
      var blue = this.rgbToHex(rgb_list[2]);

      return "#" + red + green + blue;
    },

    set_colors: function(data) {
      // first go through and count how many are in "stack 2"
      var stack_2_count = 0;
      var stack_2_data = [];
      for (var i = 0; i < data.datasets.length; i++) {
        if (data.datasets[i].group == "main") {
          stack_2_count += 1;
          stack_2_data.push(data.datasets[i]);
        }
      }

      var list_of_colors = this.interpolateColors(
        "rgb(0, 31, 255)",
        "rgb(208, 214, 255)",
        stack_2_count
      );
      var new_color = null;

      // update the main ETL colors
      for (i = 0; i < stack_2_data.length; i++) {
        new_color = list_of_colors[i];
        stack_2_data[i].backgroundColor = this.fullColorHex(new_color);
        stack_2_data[i].borderColor = "black";
        stack_2_data[i].borderWidth = "0.5";
        stack_2_data[i].borderSkipped = "bottom";
      }

      // now do the same for the post etl stuff
      stack_2_count = 0;
      stack_2_data = [];
      for (i = 0; i < data.datasets.length; i++) {
        if (data.datasets[i].group == "post-etl") {
          stack_2_count += 1;
          stack_2_data.push(data.datasets[i]);
        }
      }

      list_of_colors = this.interpolateColors(
        "rgb(0, 161, 15)",
        "rgb(152, 255, 161)",
        stack_2_count
      );

      // update the main ETL colors
      for (i = 0; i < stack_2_data.length; i++) {
        new_color = list_of_colors[i];
        stack_2_data[i].backgroundColor = this.fullColorHex(new_color);
        stack_2_data[i].borderColor = "black";
        stack_2_data[i].borderWidth = "0.5";
        stack_2_data[i].borderSkipped = "bottom";
      }

      // now do the same for the case etl stuff
      stack_2_count = 0;
      stack_2_data = [];
      for (i = 0; i < data.datasets.length; i++) {
        if (data.datasets[i].group == "cases") {
          stack_2_count += 1;
          stack_2_data.push(data.datasets[i]);
        }
      }

      list_of_colors = this.interpolateColors(
        "rgb(154, 0, 0)",
        "rgb(255, 113, 135)",
        stack_2_count
      );

      // update the main ETL colors
      for (i = 0; i < stack_2_data.length; i++) {
        new_color = list_of_colors[i];
        stack_2_data[i].backgroundColor = this.fullColorHex(new_color);
        stack_2_data[i].borderColor = "black";
        stack_2_data[i].borderWidth = "0.5";
        stack_2_data[i].borderSkipped = "bottom";
      }

      // now do the same for the POST case etl stuff
      stack_2_count = 0;
      stack_2_data = [];
      for (i = 0; i < data.datasets.length; i++) {
        if (data.datasets[i].group == "post-case-etl") {
          stack_2_count += 1;
          stack_2_data.push(data.datasets[i]);
        }
      }

      list_of_colors = [[249, 127, 0]];
      if (stack_2_count > 1) {
        list_of_colors = this.interpolateColors(
          "rgb(249, 174, 0)",
          "rgb(255, 200, 110)",
          stack_2_count
        );
      }

      // update the main ETL colors
      for (i = 0; i < stack_2_data.length; i++) {
        new_color = list_of_colors[i];
        stack_2_data[i].backgroundColor = this.fullColorHex(new_color);
        stack_2_data[i].borderColor = "black";
        stack_2_data[i].borderWidth = "0.5";
        stack_2_data[i].borderSkipped = "bottom";
      }

      return data;
    },

    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {},
  },
  // beforeRouteEnter(to, from, next) {
  //     // called before the route that renders this component is confirmed.
  //     // does NOT have access to `this` component instance,
  //     // because it has not been created yet when this guard is called!
  // },
  // beforeRouteUpdate(to, from, next) {
  //     // called when the route that renders this component has changed,
  //     // but this component is reused in the new route.
  //     // For example, for a route with dynamic params `/foo/:id`, when we
  //     // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
  //     // will be reused, and this hook will be called when that happens.
  //     // has access to `this` component instance.
  // },
  // beforeRouteLeave(to, from, next) {
  //     // called when the route that renders this component is about to
  //     // be navigated away from.
  //     // has access to `this` component instance.
  // },
};
</script>

<style>
#chartjs-tooltip {
  z-index: 500;
}
</style>
